import React from 'react';
import {
  Image,
  Text,
  TextInput,
  TextInputProps,
  TouchableOpacity,
  View,
} from 'react-native';
import {Images} from '../../constants/Images';
import {styles} from './styles';

interface IHomeInput extends TextInputProps {
  placeholder?: string;
  onPress: () => void;
  showOkButton?: boolean;
}

const HomeInput = ({
  placeholder,
  onPress,
  showOkButton = false,
  ...props
}: IHomeInput) => {
  return (
    <View style={styles.container}>
      <TouchableOpacity onPress={onPress}>
        <Image source={Images.glass} style={styles.image} />
      </TouchableOpacity>
      <TextInput
        placeholder={placeholder}
        placeholderTextColor={'lightgray'}
        style={[styles.input, showOkButton && styles.inputWithOkButton]}
        {...props}
      />
      {showOkButton && (
        <TouchableOpacity
          onPress={onPress}
          style={styles.okButton}
          activeOpacity={0.7}>
          <Text style={styles.okButtonText}>OK</Text>
        </TouchableOpacity>
      )}
    </View>
  );
};

export default HomeInput;
